import { useEffect, useState } from "react";
import { bakimDurumu, type BakimDurumu } from "./api";
import { bakimBitisMetni } from "./bakim-bitisi";

/**
 * BAKIM BANDI — F-SEC-06
 *
 * ================================================================
 * BU UYGULAMA BAKIMI HİÇ BİLMİYORDU
 * ================================================================
 * Ölçüldü (05.09.2026): `apps/ogrenci` içinde `bakim` geçen tek satır
 * yoktu. Bakım açıkken sunucu muaf olmayan her uca `503 BAKIM_MODU`
 * dönüyor; öğrenci bunun yerine her ekranda genel bir hata görüyordu.
 *
 * ================================================================
 * `react-query` DEĞİL — VE SEBEBİ ÖLÇÜLDÜ
 * ================================================================
 * Bu uygulamada `react-query` KURULU (`main.tsx` sağlayıcıyı veriyor),
 * yani ilk hâli onu kullanıyordu. Ama bant `OgrenciKabugu` içinde
 * duruyor ve kabuk, sağlayıcısı olmayan yerlerde de çiziliyor:
 * `Uygulama.test.tsx` sağlayıcı kurmuyor ve bileşen
 * *"No QueryClient set"* fırlatıp **bütün uygulamayı** düşürdü —
 * 15 test birden.
 *
 * Ders bir kütüphane tercihi değil: **kabuk düzeyinde çizilen bir şey,
 * ortam bağlamına muhtaç olmamalı.** Bir uyarı bandının kendisi hata
 * kaynağı olursa, tam da hata anında kaybolur.
 *
 * ================================================================
 * METİN SUNUCUDAN — UYDURULMUYOR
 * ================================================================
 * Yöneticinin yazdığı açıklama öğrenciye AYNEN ulaşıyor. Kendi
 * metnimizi yazsaydık "ne zaman biter" bilgisi kaybolurdu — onu
 * yalnızca bakımı açan kişi biliyor.
 */
export function BakimBandi(): React.ReactElement | null {
  const [durum, setDurum] = useState<BakimDurumu | null>(null);

  useEffect(() => {
    let iptal = false;
    const oku = (): void => {
      void bakimDurumu()
        .then((d) => {
          if (!iptal) setDurum(d);
        })
        .catch(() => {
          /*
            Durum ALINAMIYORSA bant gösterilmiyor: "bilmiyorum" hâlinde
            "bakımda" demek, çalışan bir sistemi bozuk göstermek olurdu.
            Bu uygulama çevrimdışı da çalışıyor ve o hâlde istek zaten
            düşer — öğrenciyi "bakımda" diye yanıltmamalı.
          */
          if (!iptal) setDurum(null);
        });
    };
    oku();
    // Bakım açıldığında öğrenci dakikalarca sonra öğrenmemeli;
    // kapandığında da bandın ekranda kalması yanlış bilgi olur.
    const zamanlayici = setInterval(oku, 60_000);
    return () => {
      iptal = true;
      clearInterval(zamanlayici);
    };
  }, []);

  if (!durum?.acik) return null;

  return (
    // `role="status"` — ekran okuyucu bandı DUYURSUN. Yalnızca renk ve
    // konumla anlatılan bir durum, görmeyen kullanıcı için yok.
    <div
      role="status"
      className="border-uyari-200 bg-uyari-50 text-uyari-800 flex flex-wrap items-baseline gap-x-2 gap-y-1 border-b px-4 py-2 text-sm"
    >
      <strong>{durum.baslik ?? "Bakım çalışması"}</strong>
      <span>{durum.mesaj}</span>
      {/*
        ================================================================
        "NE ZAMAN BİTECEK" — TELDE VARDI, EKRANDA YOKTU
        ================================================================
        Ölçüldü (05.09.2026): `bitisTahmini` sunucudan geliyor, `api.ts`te
        bildiriliyor, PANELDE çiziliyor (`BakimBandi.tsx:61` ve tam ekran
        `BakimModu`) — öğrenci uygulamasında hiçbir yerde.

        Ve mesajın içinde DE gelmiyor: `bakim.controller.ts` başlık,
        mesaj ve bitişi ÜÇ AYRI alan olarak alıyor. Yönetici saati
        mesaja elle yazarsa iki yerde durur ve ayrışır.

        Bakım anında öğrencinin tek sorusu bu: "ne zaman açılacak?"
        Cevabı sunucuda hazır dururken söylememek, bekleyen öğrenciyi
        dakika dakika sayfa yenilemeye bırakıyordu.

        `toLocaleTimeString` — TARİH DEĞİL SAAT: bakım penceresi
        saatlerle ölçülüyor ve "5 Eylül 03:40" yerine "03:40" okuması
        daha kolay. Gün atlarsa gün de yazılıyor.
      */}
      {durum.bitisTahmini && <span>Tahmini bitiş: {bakimBitisMetni(durum.bitisTahmini)}</span>}
    </div>
  );
}
